export type TransactionType = 'debit' | 'credit' | 'saving' | 'repayment' | 'adjustment'

export const TransactionTypeCode: Record<string, TransactionType> = {
  DEBIT: 'debit',
  CREDIT: 'credit',
  SAVING: 'saving',
  REPAYMENT: 'repayment',
  ADJUSTMENT: 'adjustment'
} as const